import { Container as NbContainer } from 'native-base';

import { addWithConfig } from '../../utils';

export const Container = NbContainer;

export default addWithConfig(Container);
